export type Users = User[];

export interface User {
  id?: string;
  firebaseId?: string;
  email: string;
  isActive?: boolean;
  lastLogin?: string;
  firstName?: string;
  lastName?: string;
  roles?: Roles;
  qr?: string;
  secret?: string;
}

export type Roles = Role[];

export interface Role {
  moduleId?: string;
  moduleName: string;
  role: RoleId;
}

export enum RoleId {
  None = 0,
  Read = 1,
  Write = 2,
  ResetFirebaseRecord = 3,
  TerminateCustomer = 4,
  ViewUserLogs = 5,
  TerminateCustomerWithoutOTP = 6,
  ProductSync = 3,
}

export type UserModules = UserModule[];

export interface UserModule {
  id: string;
  name: string;
}

export interface VerifyPayload {
  email: string;
  code: string;
}
